import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import qs from 'qs'
import {api} from '../../../api'
import {Search, Label} from 'semantic-ui-react'

class InventorySearch extends Component {
    constructor() {
        super();
        this.state ={
            isLoading: false, 
            results: [], 
            value: ''
        }
    }
    
    handleResultSelect = (e, { result }) => {
        const { inventory } = result;
        this.setState({ value: `${result.title} - ${result.description}` });
        this.props.onSelected(inventory);
    }

    handleSearchChange = (e, { value }) => {
        this.setState({ value })
        if (value.length > 2) {
            this.setState({
                isLoading: true
            })
            api.inventory.selector(this.props.jwt, {
                search: value,
                excepts: this.props.exceptIds,
                specialPricing: this.props.requireInventoryPricing,
                relationId: this.props.relationId
            }).then( options => {
                this.setState({
                    isLoading: false,
                    results: options
                })
            }).catch(err => {
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    _resultRender = (item) => {
        return <div>
            <Label pointing='right' color='violet' size='tiny'>{item.title}</Label>
            <Label size='tiny'>{item.description}</Label>
            {item.price ? <Label size='tiny' color='green'>{item.price}</Label> : null}
        </div>
    }

    render() {
        const { isLoading, value, results } = this.state
        return (
            <div style={{marginBottom: '10px'}}>
                <label>Search SKU or Name</label>
                <Search
                    resultRenderer={this._resultRender}
                    fluid={true}
                    loading={isLoading}
                    size='large'
                    onResultSelect={this.handleResultSelect}
                    onSearchChange={_.debounce(this.handleSearchChange, 1000, { leading: true })}
                    results={results}
                    value={value}
                />
            </div>
        )
    }
}

InventorySearch.propTypes = {
    jwt: PropTypes.string.isRequired,
    onSelected: PropTypes.func.isRequired,
    exceptIds: PropTypes.array.isRequired,
    requireInventoryPricing: PropTypes.bool.isRequired,
    relationId: PropTypes.string.isRequired
};

export default InventorySearch


// WEBPACK FOOTER //
// ./src/components/utils/searches/InventorySearch.js